<template>
  <div class="tile" :class="tileClass" @click="onTileClick(...tileObject.cords)" @mouseenter="mouseOn = true" @mouseleave="mouseOn = false">
    <tile-unit v-if="tileObject.unit" :unit-object="tileObject.unit" :needs-margin="unitNeedsMargin()"> </tile-unit>
    <tile-pointer v-if="tileObject.pointer.enabled" :pointer-color="getPointerColor()" :needs-margin="getUnitObject() ? true: false"> </tile-pointer>
    <tile-badge v-if="showBadge" :badge-content="badgeNumber" badge-type="vehicle"> </tile-badge>
    <tile-badge v-if="showFlagIndicator" badge-type="flag"> </tile-badge>
  </div>
</template>

<script>
import TilePointer from './BoardTile/TilePointer.vue';
import TileUnit from './BoardTile/TileUnit.vue';
import TileBadge from './BoardTile/TileBadge.vue';

export default {
  components: { TilePointer, TileUnit, TileBadge },
  inject: ['groundTypes', 'onTileClick', 'selectMode', 'game'],
  data() {
    return {
      tileUnit: null,
      mouseOn: false,
    }
  },
  props: {
    tileObject: {
      type: Object,
      required: true,
      validator(tile) {
        return tile.groundType && tile.pointer;
      }
    },
  },
  methods: {
    getUnitObject(){
      return this.tileObject.unit;
    },
    unitNeedsMargin(){
      return this.tileObject.pointer.enabled;
    },
    getPointerColor(){
      return this.tileObject.pointer.color;
    },
  },
  computed: {
    badgeNumber() {
      return this.game.countUnitsOnVehicle(this.tileObject.unit);
    },
    showBadge() {
      return this.tileObject.unit && this.tileObject.unit.isVehicle && this.badgeNumber > 0;
    },
    showFlagIndicator(){
      return this.tileObject.unit && this.tileObject.unit.isCarryingFlag;
    },
    tileClass() {
      if (this.tileObject.groundType === 's') {
        return 'sea-tile';
      }
      return 'sand-tile';
    },
  },
};
</script>

<style scoped>
.tile{
    min-width: 40px;
    min-height: 40px;
    border: 1px solid black;
    margin: 1px;
    opacity: 0.85;
    transition: opacity 0.1s;
    user-select: none;
}
.tile:hover{
    opacity: 1
}
.sea-tile{
    background-image: url(../../../public/images/water-texture.jpg);
}
.sand-tile{
    background-image: url(../../../public/images/sand-texture.jpg);
}
</style>
